import { Input, MaskedInput, Select } from '@cian/ui-kit';

import { FC } from 'react';

import { PHONE_MASK } from 'shared/constants/form/mask';

import { CustomFormField } from '../../CustomFormField';
import { FormFooterWithPrivacyPolicy } from '../../FormFooterWithPrivacyPolicy';
import { EPlacementApplicationFormFields } from '../constants';

import { companyTypeSelectOptions } from './internal/mappers/companyTypeSelectOptions';
import { IPlacementApplicationFormViewProps } from './types';

import * as styles from './PlacementApplicationFormView.css';

export const PlacementApplicationFormView: FC<IPlacementApplicationFormViewProps> = props => {
  const {
    boundActions,
    checkFormFieldInvalid,
    disableFieldsOnPending,
    getFormFieldErrorMessage,
    getFormFieldValue,
    onBlur,
    onSubmit,
    pending,
  } = props;

  return (
    <form className={styles['form-container']} onSubmit={onSubmit}>
      <div className={styles['form-group']}>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.CompanyName)}
          label="Название компании"
          testId="field_placement-name"
        >
          <Input
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EPlacementApplicationFormFields.CompanyName)}
            placeholder="Введите название компании"
            value={getFormFieldValue(EPlacementApplicationFormFields.CompanyName)}
            onBlur={onBlur(EPlacementApplicationFormFields.CompanyName)}
            onChange={boundActions.setCompanyNameFieldValueAction}
          />
        </CustomFormField>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.CompanyType)}
          label="Вид деятельности"
        >
          <Select
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EPlacementApplicationFormFields.CompanyType)}
            options={companyTypeSelectOptions}
            placeholder="Выберите вид деятельности"
            value={getFormFieldValue(EPlacementApplicationFormFields.CompanyType)}
            onChange={boundActions.setCompanyTypeFieldValueAction}
          />
        </CustomFormField>

        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.Phone)}
          label="Номер телефона"
          testId="field_placement-phone"
        >
          <MaskedInput
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EPlacementApplicationFormFields.Phone)}
            mask={PHONE_MASK}
            placeholder="+7"
            value={getFormFieldValue(EPlacementApplicationFormFields.Phone)}
            onBlur={onBlur(EPlacementApplicationFormFields.Phone)}
            onChange={boundActions.setPhoneFieldValueAction}
          />
        </CustomFormField>

        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.Email)}
          label="E-mail"
          testId="field_placement-email"
        >
          <Input
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EPlacementApplicationFormFields.Email)}
            placeholder="Введите e-mail"
            value={getFormFieldValue(EPlacementApplicationFormFields.Email)}
            onBlur={onBlur(EPlacementApplicationFormFields.Email)}
            onChange={boundActions.setEmailFieldValueAction}
          />
        </CustomFormField>
      </div>

      <FormFooterWithPrivacyPolicy buttonDisabled={pending} submitButtonTitle="Отправить заявку" />
    </form>
  );
};

PlacementApplicationFormView.displayName = 'PlacementApplicationFormView';
